<template>
  <card
    title="מכשירים לא פעילים אצל לקוחות "
    :linkTo="`/devices?networkStatusTypes=${suspendedStatusId}&bookedOut=true`"
    actionButton="לכל המכשירים הלא פעילים"
    :number="number"
    :loading="loading"
    :error="error"
  />
</template>

<script>
import { format, addDays } from 'date-fns';
import { getApi } from '@/api';
import Card from "./Card.vue";

export default {
  data() {
    return {
      number: 0,
      loading: false,
      error: false
    };
  },

  computed: {
    suspendedStatusId(){
      let suspendedStatus = Object.values(this.$store.state.entities.networkStatusTypes).find(item =>{
        return item.title === 'suspended';
      })
      return suspendedStatus ? suspendedStatus._id: null;
    },

  },

  methods: {
    format,
    addDays,
    fetchData() {
      this.loading = true;
      getApi()
        .then(api => {
          let params = {
            networkStatusTypes: this.suspendedStatusId,
            bookedOut: true
          };
          return api.get('/devices', { params })
        })
        .then(({ data }) => {
          this.number = data.totalResults;
        })
        .catch(err => {
          console.log(err);
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        })
    }
  },

  props: [],

  mounted() {
    this.fetchData();
  },

  components: {
    Card
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
